<template>
  <div>
    <h2>Email Templates</h2>
    <hr>
    <h4 class="mb-4">The templates marked type "Nanny" are for nannies in THIS platform, the ones marked "Candidate" will be used in the new platform.</h4>

    <button class="mylisting-button dark-button mb-4" @click="showTemplateModal()">Add Template</button>
    
    <!-- <button class="mylisting-button dark-button mb-4" @click="duplicateTemplates()">Duplicate Templates</button> -->
    
    <div v-for="(template, index) in templates" :key="'Template'+index">
      <!-- {{ template }} -->
      <h3>Name: {{ template.name }} <img src="../../../assets/img/icons/edit_icon_simple.svg" @click="showTemplateModal(template)" style="width: 15px;"></h3>
      <h5>Type: {{ template.selector1 }}</h5>
      <h5>Trigger: {{ template.type }}</h5>
      <h5>Status: {{ template.status }}</h5>
      <h5 v-if="template.selector2">Category: {{ template.selector2 }}</h5>
      <p class="">Sender Email: {{ template.from_email }}</p>
      <p class="mb-2">Subject: {{ template.subject }}</p>
      <pre>{{ template.body }}</pre>
      <hr>
    </div>

    <modal name="template-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <label style="margin-top: 0;">Name</label>
        <input type="text" class="form-control" placeholder="Give the template a human readable name for your reference" v-model="name">
        <label>Subject</label>
        <input type="text" class="form-control" placeholder="" v-model="subject">
        <label>Body</label>
        <textarea rows="14" v-model="body" class="form-control"></textarea>
        <p>Use [[fname]] for first name.</p>
        <label>Sender Email</label>
        <input type="text" class="form-control" placeholder="" v-model="fromEmail">
        <div class="row">
          <div class="col-lg-4">
            <label>Trigger</label>
            <div class="" style="">
              <multiselect
                v-model="type"
                :options="types"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Trigger"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4">
            <label>Type</label>
            <div class="" style="">
              <multiselect
                v-model="selector1"
                :options="selector1Options"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Type"
              ></multiselect>
            </div>
          </div>
          <!-- <div class="col-lg-3">
            <label>Category</label>
            <div class="" style="">
              <multiselect
                v-model="selector2"
                :options="selector2Options"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Category"
              ></multiselect>
            </div>
          </div> -->
          <div class="col-lg-4">
            <label>Status</label>
            <div class="" style="">
              <multiselect
                v-model="status"
                :options="statuses"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Status"
              ></multiselect>
            </div>
          </div>

        </div>

        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-modal')">Cancel</button>
        <button v-if="!template.id" class="mylisting-button dark-button" @click="postTemplate()" style="float: right;">Create</button>
        <button v-if="template.id" class="mylisting-button dark-button" @click="updateTemplate()" style="float: right;">Update</button>
      </div>
    </modal>

    <modal name="template-created-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3>Template created.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-created-modal')">Close</button>
      </div>
    </modal>

    <modal name="template-updated-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3>Template updated.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-updated-modal')">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      templates: [],
      template: {},

      editing: false,

      status: '',
      // statuses: [],
      type: '',
      types: [
        'Status Change Notification',
        // 'Status Reminder',
      ],
      selector1Options: [
        'Candidate', 'Employer', 'Job'
      ],
      selector1: '',
      // selector2Options: [
      //   '',
      // ],
      selector2: '',
      subject: '',
      body: '',
      name: '',
      // fromEmail: this.$store.getters.agencyAdminEmail,
      fromEmail: 'goldcoastnannies@enginehire.io',
    }
  },
  computed: {
    statuses() {
      if (this.selector1 == 'Candidate') {
        return this.$store.getters.candidateStatuses
      }
      else if (this.selector1 == 'Employer') {
        return this.$store.getters.employerStatuses
      }
      else {
        return []
      }
    },
    selector2Options() {
      if (this.selector1 == 'Candidate') {
        return this.$store.getters.candidateTypes
      }
      else if (this.selector1 == 'Employer') {
        return this.$store.getters.employerTypes
      }
      else {
        return []
      }
    },
  },
  created() {
    this.getTemplates()
    // this.statuses = this.$store.getters.statuses
  },
  methods: {
    getTemplates() {
      axios.get(`/api/emailtemplates/?agency=${this.$store.getters.agencyID}`)
        .then(res => {
          this.templates = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showTemplateModal(template) {
      if (template) {
        this.template = template
        this.subject = template.subject
        this.status = template.status
        this.type = template.type
        this.name = template.name
        this.body = template.body
        if (template.from_email) {
          this.fromEmail = template.from_email
        }
        this.selector1 = template.selector1
        this.selector2 = template.selector2
      }
      else {
        this.subject = ''
        this.status = ''
        this.type = ''
        this.name = ''
        this.body = ''
        this.fromEmail = this.$store.getters.agencyAdminEmail
        this.selector1 = ''
        this.selector2 = ''
        this.template = {}
      }
      this.$modal.show('template-modal')
    },
    postTemplate() {
      axios.post(`/api/emailtemplates/`, {
        name: this.name,
        status: this.status,
        type: this.type,
        subject: this.subject,
        body: this.body,
        from_email: this.fromEmail,
        selector1: this.selector1,
        selector2: this.selector2,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          this.getTemplates()
          this.$modal.hide('template-modal')
          this.$modal.show('template-created-modal')
        })
    },
    updateTemplate() {
      axios.patch(`/api/emailtemplates/${this.template.id}/`, {
        name: this.name,
        status: this.status,
        type: this.type,
        subject: this.subject,
        body: this.body,
        from_email: this.fromEmail,
        selector1: this.selector1,
        selector2: this.selector2,
        // agency_owner: this.$store.getters.agencyName,
        // agency: this.$store.getters.agencyID,
      })
        .then(res => {
          this.getTemplates()
          this.$modal.hide('template-modal')
          this.$modal.show('template-updated-modal')
        })
    },

    duplicateTemplates() {
      let count = 0 

      for (const template of this.templates) {
        if (template.selector1 == 'Candidate') {
          axios.post(`/api/emailtemplates/`, {
            name: template.name,
            status: template.status,
            type: template.type,
            subject: template.subject,
            body: template.body,
            from_email: template.from_email,
            selector1: 'Nanny',
            selector2: template.selector2,
            deactivated: template.deactivated,
            agency_owner: this.$store.getters.agencyName,
            agency: this.$store.getters.agencyID,
          })
            .then(res => {
              console.log(res)
              // this.getTemplates()
              // this.$modal.hide('template-modal')
              // this.$modal.show('template-updated-modal')
            })

          count += 1
          // if (count == 1) {
          //   break 
          // }
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/systems/EmailTemplates.vue